<template>
  <div style="width: 100%; height: calc(100% - 32px)">
    <div ref="myChart" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
export default {
  name: 'LineChart',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    dataValue: {
      type: Object,
      default: () => ({})
    },
    deviceName: {
      type: String,
      default: ''
    },
    oeeOption: {
      type: String,
      default: ''
    },
    color: {
      type: Array,
      default: () => []
    },
    tabIndex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      myChart: null
    }
  },
  computed: {
    chartOption() {
      const xAxisData = []
      this.columns.forEach((item) => {
        xAxisData.push(item.title)
      })
      // 指定图表的配置项和数据
      var option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis'
        },
        color: this.color,
        // legend: {
        //   show: this.dataValue.length > 1,
        //   data: [this.deviceName],
        //   selectedMode: false
        // },
        grid: {
          top: '20',
          left: '20',
          right: '20',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            show: true,
            // interval: 0,
            formatter: (val) => {
              var strs = val.split('') //字符串数组
              var str = ''
              for (var i = 0, s; (s = strs[i++]); ) {
                //遍历字符串数组
                str += s
                if (!(i % 7)) str += '\n' //按需要求余
              }
              return str
            }
          },
          axisLine: { onZero: true },
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          boundaryGap: true,
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            formatter: (value) => {
              return value + '%'
            }
          }
        },
        series: {
          name: this.deviceName,
          type: 'line',
          data: this.seriesDataItem(this.dataValue)
        },
        tooltip: {
          trigger: 'axis',
          formatter: '{a}<br />{b}:  {c} %'
        }
      }
      return option
    }
  },
  watch: {
    chartOption: {
      handler(val, oldVal) {
        this.myChart.setOption(val, true)
        this.myChart.resize()
      },
      deep: true
    },
    tabIndex: {
      handler() {
        if (this.myChart) {
          this.myChart.resize()
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.myChart = this.$echarts.init(this.$refs.myChart)
    this.myChart.setOption(this.chartOption)
  },
  methods: {
    seriesDataItem(obj) {
      const data = []
      if (this.oeeOption === '1') {
        Object.keys(obj).forEach(function(key) {
          const value = obj[key] * 100
          data.push(value.toFixed(2))
        })
      } else {
        Object.keys(obj)
          .sort()
          .forEach(function(key) {
            const value = obj[key] * 100
            data.push(value.toFixed(2))
          })
      }
      return data
    }
  }
}
</script>

<style scoped></style>
